export default __webpack_public_path__ + "static/media/destroyed_36@2x.8f9550b5.png";